import { Stack } from '@mui/material';

import { DateRangeSelect } from '../../../../components/DateRangeSelect/DateRangeSelect';
import { BaseDomainType } from '~/common/types';
import { BaseDetailHeader } from '~/components/BaseDetailHeader/BaseDetailHeader';
import { BasePageTitle } from '~/components/BasePageTitle/BasePageTitle';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ResponsibleUsersSelect } from '~/components/ResponsibleUsersSelect/ResponsibleUsersSelect';
import { ModuleSlotId } from '~/modules';
import { useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

const domain = BaseDomainType.GENERAL;

export const BaseGeneral = () => {
  const { tabId } = useTabId();
  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.analyticsGeneral, tabId });

  return (
    <DateRangeProvider>
      <ResponsibleUsersProvider>
        <ModulePage
          header={
            <BaseDetailHeader
              title={<BasePageTitle domain={domain} />}
              tabs={tabs}
              actionsRight={
                <Stack
                  spacing={3}
                  direction="row"
                  sx={{
                    padding: 1,
                    overflow: 'hidden',
                    alignItems: 'center',
                  }}
                >
                  <ResponsibleUsersSelect />
                  <DateRangeSelect />
                </Stack>
              }
            />
          }
          modules={<ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />}
        />
      </ResponsibleUsersProvider>
    </DateRangeProvider>
  );
};
